<template>
  <div class="flex flex-col items-center bg-light-bg dark:bg-dark-bg min-h-screen text-light-text dark:text-dark-text">
    <AppSidebar />

    <div class="w-full max-w-4xl bg-white dark:bg-dark-box-bg rounded-lg shadow-md p-6 mt-6">
      <button
          @click="goToCompanies"
          class="mb-4 text-teal-700 dark:text-teal-400 hover:underline flex items-center"
      >
        &larr; Wróć do zakładki firm
      </button>

      <div v-if="company">
        <h2 class="text-2xl font-bold mb-6">Profil Firmy</h2>

        <!-- Information Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-6 mb-6">
          <div class="space-y-2">
            <p><strong>Nazwa firmy:</strong> {{ company.companyName }}</p>
            <p><strong>ID:</strong> {{ company.id }}</p>
            <p><strong>NIP:</strong> {{ company.companyNip }}</p>
          </div>
          <div class="space-y-2">
            <p><strong>Adres:</strong> {{ company.companyAddress }}</p>
            <p><strong>Telefon:</strong> {{ company.phone }}</p>
          </div>
        </div>

        <hr class="my-6 border-light-border dark:border-dark-border">

        <!-- Orders Section -->
        <h4 class="text-lg font-semibold mb-4">Przypisane Zamówienia</h4>
        <div class="overflow-x-auto">
          <table class="w-full border-collapse border border-light-border dark:border-dark-border">
            <thead>
            <tr class="bg-light-table-header dark:bg-dark-table-header">
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">#</th>
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Numer Zamówienia</th>
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Data</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(order, index) in company.orders"
                :key="order.id"
                class="hover:bg-light-hover dark:hover:bg-dark-hover cursor-pointer"
                @click="goToProfile(order)"
            >
              <td class="border border-light-border dark:border-dark-border px-4 py-2">{{ index + 1 }}</td>
              <td class="border border-light-border dark:border-dark-border px-4 py-2 text-teal-700 dark:text-teal-400 hover:underline">
                Zamówienie #{{ order.mpk }}
              </td>
              <td class="border border-light-border dark:border-dark-border px-4 py-2">
                {{ new Date(order.date).toLocaleDateString() }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Loading State -->
      <div v-else-if="loading" class="text-gray-500 dark:text-gray-400">
        <p>Ładowanie danych firmy...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="errorMessage" class="text-red-500 dark:text-red-400">
        <p>{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>


<script>
  import { useAuthStore } from '@/stores/authStore';
  import companiesService from '@/services/companiesService';
  import AppSidebar from "@/components/AppSidebar.vue";
  
  export default {
    name: 'CompanyProfile',
    components: {AppSidebar},
    data() {
      return {
        company: null,
        loading: true,
        errorMessage: ''
      };
    },
    setup() {
      const authStore = useAuthStore();
      authStore.checkExpiration();
      return { user: authStore.user };
    },
    mounted() {
      this.fetchCompany();
    },
    methods: {
      async fetchCompany() {
        const companyId = this.$route.params.id; // Pobieramy id z parametrów URL
        try {
          const response = await companiesService.getCompanyById(companyId);
          this.company = response.data;
          this.loading = false;
        } catch (error) {
          this.errorMessage = 'Error fetching company details. Please try again.';
          this.loading = false;
        }
      },
      goToCompanies() {
        const returnTo = this.$route.query.returnTo;
        const currentPage = this.$route.query.currentPage;
        if (returnTo) {
          this.$router.push({ 
            name: returnTo,
            query: {currentPage: currentPage}  
          });
        } else {
          if (this.user.role === 'ROLE_ADMIN') {
            this.$router.push({
              name: 'CompaniesPageAdmin',
              query: {currentPage: currentPage} 
            });
          } else {
            this.$router.push({
              name: 'CompaniesPageDispatcher',
              query: {currentPage: currentPage} 
            });
          }
        }
      },
      goToProfile(order) {
        if (this.user.role === 'ROLE_ADMIN') {
          this.$router.push({
            name: 'OrderProfileAdmin', 
            params: {id: order.id},
            query: {
              returnTo: this.$route.name,
              companyId: this.company.id,
            }
          });
        } else {
          this.$router.push({
            name: 'OrderProfileDispatcher', 
            params: {id: order.id},
            query: {
              returnTo: this.$route.name,
              companyId: this.company.id,
            }
          });
        }
      }
    }
  };
  </script>